<template>
    <div>
      <Pos_invoices_tax_detail/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_detail from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_detail";
  export default {
    name: "PosInvoicesTaxDetail",
    components: {
      Pos_invoices_tax_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  